import Editor from ".";
import { nanoid } from "nanoid";
import { HE } from "../types";
import { parseHtmlString, prepareElement, showHtmlCss } from "../utils/helpers";

const click = (e: MouseEvent, editor: Editor) => {
  e.preventDefault();
  e.stopPropagation();

  if (editor.getSelectedEl() === e.target) {
    editor.showStylePanel();
    return;
  }

  const BlockManager = editor.getBM();
  const document = editor.getDocument();
  const elem = document?.querySelector(".selected") as HE;

  if (elem instanceof NodeList) {
    elem.forEach((el) => {
      (el as HE).classList.remove("selected");
    });
  } else if (elem) {
    elem.classList.remove("selected");
  }

  if (e.target instanceof Element || e.target) {
    const elem = e.target as HE;
    elem.classList.add("selected");
    let cmpType = elem.getAttribute("cmp-type") as string;
    editor.setSelectedEl(elem as HE);
    editor.selectedBlock = BlockManager.blocks[cmpType];
    editor.showStylePanel();
    editor.showToolbar();
  }

  showHtmlCss(e.target as HE, editor);
};

const mouseOver = (e: MouseEvent, editor: Editor) => {
  e.preventDefault();
  const document = editor.getDocument();
  const elem = document?.querySelector(".mouseover") as HE;

  if (elem instanceof NodeList) {
    elem.forEach((el) => {
      (el as HE).classList.remove("mouseover");
    });
  } else if (elem) {
    elem.classList.remove("mouseover");
  }

  if (e.target instanceof Element || e.target) {
    // @ts-ignore
    e.target.classList.add("mouseover");
  }
};

const mouseLeave = (e: MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();

  if (e.target instanceof Element || e.target) {
    // @ts-ignore
    e.target.classList.remove("mouseover");
  }
};

const dragOver = (e: MouseEvent, elem: HE) => {
  e.preventDefault();
  e.stopPropagation();
};

const dragLeave = (e: MouseEvent, elem: HE) => {
  e.preventDefault();
  e.stopPropagation();
};

const drop = (e: DragEvent, elem: HE, editor: Editor) => {
  e.preventDefault();
  e.stopPropagation();

  const BlockManager = editor.getBM();
  const Config = editor.getConfig();
  const parent = e.target as HE;
  const isDroppable = parent.getAttribute("droppable") || "true";

  if (isDroppable === "false") {
    return;
  }

  const type = e.dataTransfer?.getData("text");
  const block = BlockManager.blocks[type || ""];

  if (!block) {
    return;
  }

  const parsedContent = parseHtmlString(block.content);

  if (!parsedContent) {
    return;
  }

  const preparedElem = prepareElement(parsedContent[0] as HE, editor);

  preparedElem.id = nanoid(10);
  preparedElem.setAttribute("cmp-type", block.type);
  preparedElem.setAttribute("droppable", block["droppable"].toString());
  preparedElem.setAttribute("draggable", block["droppable"].toString());
  parent.append(preparedElem);

  // @ts-ignore-next-line
  if (Config.selectOnDrop) {
    preparedElem.click();
  }
};

const copyEl = (editor: Editor) => {
  const elemToCopy = editor.getSelectedEl() as HE;
  const clonedComp = elemToCopy.cloneNode(true) as HE;

  clonedComp.id = nanoid(10);

  elemToCopy?.parentNode?.insertBefore(
    elemToCopy.cloneNode(true),
    elemToCopy.nextSibling
  );

  if (elemToCopy.nextSibling instanceof HTMLElement) {
    elemToCopy.nextSibling.click();
  }
};

const deleteEl = (editor: Editor) => {
  // @ts-ignore-next-line
  editor.getSelectedEl().remove();
  editor.getToolbarEl().style.display = "none";
};

export {
  click,
  mouseOver,
  mouseLeave,
  dragOver,
  dragLeave,
  drop,
  copyEl,
  deleteEl,
};
